import { render, staticRenderFns } from "./performanceStatistics.vue?vue&type=template&id=6f056c7a&scoped=true"
import script from "./performanceStatistics.vue?vue&type=script&lang=js"
export * from "./performanceStatistics.vue?vue&type=script&lang=js"
import style0 from "./performanceStatistics.vue?vue&type=style&index=0&id=6f056c7a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f056c7a",
  null
  
)

export default component.exports